import AssignmentSchedule from "./partials/AssignmentSchedule";
import ProctoringSelect from "./partials/ProctoringSelect";
import QuestionSelection from "./partials/QuestionSelection";

const StepFour = () => {
  return (
    <div className="min-h-full flex flex-col overflow-y-hidden text-sm xl:text-base">
      <AssignmentSchedule />
      <ProctoringSelect />
      <QuestionSelection />
    </div>
  );
};

export default StepFour;
